import { Plus } from "lucide-react";

interface FabProps {
  onClick: () => void;
  /** Accessible name — required because the button is icon-only. */
  label: string;
}

/**
 * Mobile-only Floating Action Button for page-level create actions.
 * Sits above the BottomTabBar (--tabbar-height) with a 12px gap and respects the
 * safe-area inset; hidden from sm up where pages show their inline
 * header button instead.
 */
export default function Fab({ onClick, label }: FabProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className="sm:hidden fixed right-4 bottom-[calc(env(safe-area-inset-bottom)+var(--tabbar-height)+0.75rem)] z-30 flex h-14 w-14 items-center justify-center rounded-full bg-primary-500 text-white shadow-lg shadow-primary-500/40 transition-colors hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
    >
      <Plus className="h-6 w-6" aria-hidden="true" />
    </button>
  );
}
